exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".news-item{color:#000}.news-item .title{color:#ff7900}.news-item-container{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/styles/NewsItem.css
// module id = 351
// module chunks = 0